export default "__VITE_ASSET__InHX$vXb__"